export const MINIMUM_SEND_SPEED = 120;
export const MAXIMUM_SEND_SPEED = 300000;
export const STAGGER_EMAIL_SEND_SPEED = {
  REGULAR: 'regular',
  THROTTLE: 'throttle'
};
export const SEND_SPEED_ERRORS = {
  ABOVE_MAX: 'aboveMax',
  BELOW_MIN: 'belowMin',
  BELOW_DYNAMIC_MIN: 'belowDynamicMin',
  EXCEEDS_THRESHOLD: 'exceedsThreshold',
  EMPTY: 'empty'
};
export const ADVANCED_SETTINGS_ACCORDION = 'advanced-settings-accordion';